import styled from '@emotion/styled';
import {Dropdown} from '@bosch/react-frok';

export const DropdownInput = styled(Dropdown)`
    max-width: 45%;
    min-width: 340px;
    margin: 0.5rem 0.5rem 0 0;
`;
